import React,{useContext, useMemo} from 'react';
import { useOffline } from '../../contexts/OfflineContext'; // Import the useOffline hook
import { ProjectContext } from '../../contexts/ProjectContext'; // Import the ProjectContext

const OfflineBar: React.FC<any> = () => {
  const isOffline = useOffline(); // Get the offline status from context

  const projectContext = useContext(ProjectContext);


  const downloadedProjectBy= useMemo(() => {

    if (projectContext.project && projectContext.project.offline_projects && projectContext.project.offline_projects[0]){
      return projectContext.project.offline_projects[0]?.user.first_name + ' ' + projectContext.project.offline_projects[0]?.user.last_name;
  }


    return null;
  }
  , [projectContext.project]);

  if (!isOffline && downloadedProjectBy) {
    return (
      <div
        style={{
          backgroundColor: '#FF4C51',
          color: 'white',
          textAlign: 'center',
          padding: '10px',
          fontSize: '16px',
          width: '100%',
        }}
      >
       This project has been downloaded by {downloadedProjectBy} and an inspection is ongoing.
       Some feature have been disabled until the inspection is completed and has been uploaded
      </div>
    )
  }

if(isOffline){
  return (
    <div
      style={{
        backgroundColor: '#FF4C51',
        color: 'white',
        textAlign: 'center',
        padding: '10px',
        fontSize: '16px',
        width: '100%',
      }}
    >
      You are offline. Some features may not be available.
    </div>
  );
}
else {
  return null;
}
};

export default OfflineBar;
